import { useMutation, useQueryClient } from '@tanstack/react-query';

import { CategoryError } from '@/exceptions/category/category.enum';
import { ICategoryDto } from '@/interfaces/entities/category';
import { categoryService } from '@/services/category.service';

const useUpdateCategory = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async ([categoryId, category]: [number, ICategoryDto]) =>
			await categoryService.editCategory(categoryId, category),

		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['category'] });
		},

		onError: () => {
			throw new Error(CategoryError.EDIT_ERROR);
		},
	});
};

export default useUpdateCategory;
